/*
 * single apostrophe symbols: ‘ ’
 *
 * If single apostrophe symbols are detected, replace with single prime mark (')
 *
 * */
export const replaceApostropheWithPrimeMark = (text = '') => {
  const pattern = /[‘’]/g;
  const hasApostrophe = pattern.test(text);
  if (hasApostrophe) {
    return text.replace(pattern, "'");
  }
  return text;
};

export const replaceApostropheWithPrimeMarkAndRemoveSpace = (text = '') => {
  const nonSpaceText = text.trim().replace(/\s+/g, ' ')?.toLowerCase();
  const pattern = /[‘’]/g;
  const hasApostrophe = pattern.test(nonSpaceText);
  if (hasApostrophe) {
    return nonSpaceText.replace(pattern, "'");
  }
  return nonSpaceText;
};
